<div class="advisor-area color bg-f9f9f9 pt-100">
    <div class="container">
        <div class="section-title">
            <!-- <span class="sub-title">Instructeur</span> -->
            <h2>Enseignants</h2>
            <p>Des intervenants ayant un témoignage rempli de l’esprit et éprouvé par la Parole.</p>
        </div>
        <div class="advisor-slides">
            <owl-carousel-o [options]="advisorSlides">
                <!-- <ng-template carouselSlide>
                    <div class="single-advisor-box">
                        <div class="row align-items-center">
                            <div class="col-lg-4 col-md-12">
                                <div class="advisor-image">
                                    <img src="https://firebasestorage.googleapis.com/v0/b/mobilechurch-294e1.appspot.com/o/images%2Fpredicateur%2Flevi1.jpg?alt=media&token=f7571464-8ec1-4c01-af81-56449f04107d" alt="image">
                                </div>
                            </div>
                            <div class="col-lg-8 col-md-12">
                                <div class="advisor-content">
                                    <h3><a routerLink="/profile">Lévi Besseghe</a></h3>
                                    <span class="sub-title">Ancien</span>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dol aliqua.</p>
                                    <ul class="social-link">
                                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template> -->
                <ng-template carouselSlide>
                    <div class="single-advisor-box">
                        <div class="row align-items-center">
                            <div class="col-lg-4 col-md-12">
                                <div class="advisor-image">
                                    <img src="https://firebasestorage.googleapis.com/v0/b/mobilechurch-294e1.appspot.com/o/images%2Fpredicateur%2Flaurence.jpg?alt=media&token=fe670b26-69b6-486d-aace-ccd35ca226e7" alt="image">
                                </div>
                            </div>
                            <div class="col-lg-8 col-md-12">
                                <div class="advisor-content">
                                    <h3><a routerLink="/profile">Laurence Ndong</a></h3>
                                    <span class="sub-title">Pasteur</span>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dol aliqua.</p>
                                    <ul class="social-link">
                                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <!-- <ng-template carouselSlide>
                    <div class="single-advisor-box">
                        <div class="row align-items-center">
                            <div class="col-lg-4 col-md-12">
                                <div class="advisor-image">
                                    <img src="assets/img/advisor/img3.jpg" alt="image">
                                </div>
                            </div>
                            <div class="col-lg-8 col-md-12">
                                <div class="advisor-content">
                                    <h3><a routerLink="/profile">James Andy</a></h3>
                                    <span class="sub-title">QA Project Expert</span>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dol aliqua.</p>
                                    <ul class="social-link">
                                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template> -->
            </owl-carousel-o>
        </div>
    </div>
</div>